// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Sy6y","productName":"Table_productName__27PZE"};